import { Navigate, useLocation } from 'react-router-dom';

interface ProtectedRouteProps {
  children: JSX.Element;
  requiredRole?: 'brand' | 'agency' | ('brand' | 'agency')[];
}

import { checkInactivity, clearSession, updateActivity } from '../utils/sessionManager';

export default function ProtectedRoute({ children, requiredRole }: ProtectedRouteProps) {
  const location = useLocation();
  const accountType = localStorage.getItem('account_type');
  const accessToken = localStorage.getItem('access_token');

  const hasRequiredRole = !requiredRole
    ? true
    : Array.isArray(requiredRole)
      ? requiredRole.includes(accountType as any)
      : accountType === requiredRole;

  if (!accessToken || !hasRequiredRole) {
    return <Navigate to="/?login=true" replace />;
  }

  // Check client-side inactivity timeout
  if (checkInactivity(false)) {
    clearSession(false);
    return <Navigate to="/?login=true" replace />;
  }

  // Touch activity timestamp on routing transition
  updateActivity(false);

  if (accountType === 'agency' && !localStorage.getItem('agency_id')) {
    return <Navigate to="/?login=true" replace />;
  }

  if (accountType === 'brand' && !localStorage.getItem('user_id')) {
    return <Navigate to="/?login=true" replace />;
  }

  if (accountType === 'brand') {
    const websiteGatedPaths = ['/dashboard'];
    if (websiteGatedPaths.includes(location.pathname)) {
      const websiteUrl = localStorage.getItem('website_url');
      if (!websiteUrl) {
        return <Navigate to="/marketing-dashboard" replace />;
      }

      // SEO Manager requires keyword universe to be finalized in Utility Manager
      if (location.pathname === '/dashboard') {
        const keywordsLocked = localStorage.getItem('keywords_locked');
        if (keywordsLocked === 'false') {
          return <Navigate to="/marketing-dashboard" replace />;
        }
      }
    }
  }

  return children;
}
